<template>
  <div class="student-view__panel-content">
    <loading v-if="!contracts" full-screen="false" size="small" />
    <div v-else-if="contracts.length === 0" class="centralized-horizontal">
      <p class="centralized-horizontal-item">
        Não existem contratos para esta cobrança
      </p>
    </div>
    <div v-else v-for="contract in contracts" :key="contract.id" class="panel panel-primary contract__panel">
      <button
        :aria-expanded="startsOpenned(contract)"
        :class="{ collapsed: !startsOpenned(contract) }"
        class="btn btn-default contract-list__expand-btn"
        data-toggle="collapse"
        :data-target="`#contract-tab-${contract.id}`"
      >
        <span>
          <span>
            <strong>Vigente até {{ contract.end_date | formatDate }} - {{ contract.translated_contract_type }}</strong>
          </span>
          &nbsp;
          <span class="label label-white" :class="getClassForContractStatusTab(contract)">
            {{ contract.translated_status }}
          </span>
          &nbsp;
          <span v-if="!businessRuleGroupCongigured()" class="label label-white label-danger">
            BRG não configurado
          </span>
        </span>
        <span class="colalapse--opened glyphicon glyphicon-menu-up" aria-hidden="true"></span>
        <span class="colalapse--closed glyphicon glyphicon-menu-down" aria-hidden="true"></span>
      </button>
      <div :id="`contract-tab-${contract.id}`"
           :aria-expanded="startsOpenned(contract)"
           :class="{ in: startsOpenned(contract) }"
           class="collapse"
      >
        <contract-view :contract="contract" :billing="billing" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Loading from 'components/Loading';
import ContractView from './ContractView';

export default {
  components: {
    Loading,
    ContractView,
  },
  props: {
    billing: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState([
      'studentContracts',
    ]),
    contracts() {
      if (!this.studentContracts) return null;

      return this.studentContracts
        .filter(contract => contract.billing_id === this.billing.id)
        .sort((a, b) => b.id - a.id)
        .sort(this.sortContracts);
    },
  },
  methods: {
    sortContracts(a, b) {
      return (a.status === 'canceled' && b.status !== 'canceled') ? 1 : -1;
    },
    startsOpenned(contract) {
      return contract.status === 'active';
    },
    getClassForContractStatusTab(contract) {
      switch (contract.status) {
        case 'finished': return 'label-success';
        case 'canceled': return 'label-danger';
        default: return 'label-primary';
      }
    },
    businessRuleGroupCongigured() {
      return this.billing.business_rule_group_id !== null;
    },
  },
};
</script>
